import { getEventBusIfDefined } from '@cian/event-bus';

require('./style.css');

import {
  reloadHeader,
  setActiveBottomMenuItem,
  submitGA,
  submitMobileMenuGA,
  updateFavorites,
  waitForLoginPopup,
  initializeStuff,
  removeRedwareCookies,
  setNewbuildingConsultantPhone,
} from './util';
import { initializeGeoSwitcher } from './services/geoSwitcher';
import { setFingerprintCookie } from './utils/fingerprint';
import { IHeaderV1Schema } from '../shared/repositories/header/entities/response/HeaderV1Schema';
import { initializeChatsNotificator, initializeChatsCounter, initializeNewChatsNotificator } from './services/chats';
import { handleDownloadAppClick } from './utils/handleDownloadAppClick';
import { initializeNotificationCenter } from './services/notificationCenter';
import { getConfig } from '@cian/config/browser';
import {
  initializeCheckAnounceRelevancePopup,
  initializeProlongationPopup,
  initializeModerationCheckConstraint,
} from './services/moderation';
import { initializeBackToAdPopup } from './services/backToAdPopup';
import { initializeFavorites } from './services/favorites';
import { initializeUserMenu } from './services/userMenu';
import { initializeDropdownMenus, initializeNewTopMenu } from './services/dropdownMenus';
import { initializeSpecialPromoLink } from './services/specialPromoLink';
import { initializeCookieAgreement } from './services/cookieAgreement';
import { initializeBottomMenu } from './services/bottomMenu';
import {
  trackRealtorMenuItemClick,
  trackMortgageMenuItemClick,
  trackMortgageCalculatorMenuItemClick,
  trackRealtorMenuItemShown,
  trackMortgageMenuItemShown,
} from './utils/analytics';
import { setActiveNewBottomMenuItem } from './utils/setActiveNewBottomMenuItem';

const burger = document.getElementById('burger');
const menuBg = document.getElementById('nav-bg');
const closeButton = document.getElementById('nav-close');
const notificationButton = document.getElementById('c-header__notifications-mobile-wrapper');
const downloadAppButton = document.getElementById('download-app');
const adaptiveMenu = document.getElementById('adaptive-menu');
const menu = document.getElementById('adaptive-header');
const body = document.querySelector('body');
const html = document.documentElement;

let htmlOverflow = '';
let bodyOverflow = '';

if (burger) {
  burger.onclick = () => {
    if (burger && adaptiveMenu && menu && body) {
      adaptiveMenu.className += ' c-header__main-nav-opened';
      adaptiveMenu.classList.remove('c-header__main-nav-hidden');
      menu.className += ' c-header-opened';
      htmlOverflow = html.style.overflow;
      bodyOverflow = body.style.overflow;
      // Если не скрывать переполнение для html - скрытие не работает должным образом на ios
      html.style.overflow = 'hidden';
      body.style.overflow = 'hidden';

      // Отправляем событие аналитики показа пункта меню "Помощь риелтора"
      trackRealtorMenuItemShown();
      trackMortgageMenuItemShown();
    }
  };
}

const closeMenu = () => {
  if (adaptiveMenu && menu) {
    adaptiveMenu.classList.remove('c-header__main-nav-opened');
    menu.classList.remove('c-header-opened');
    setTimeout(() => {
      if (adaptiveMenu && body) {
        adaptiveMenu.className += ' c-header__main-nav-hidden';
        html.style.overflow = htmlOverflow;
        body.style.overflow = bodyOverflow;
      }
    }, 300);
  }
};

const closeMenuWithOpenNotifications = () => {
  document.dispatchEvent(new CustomEvent('openNotificationCenter'));
  closeMenu();
};

if (menuBg) {
  menuBg.onclick = closeMenu;
}

if (closeButton) {
  closeButton.onclick = closeMenu;
}

if (notificationButton) {
  notificationButton.onclick = closeMenuWithOpenNotifications;
}

if (downloadAppButton) {
  downloadAppButton.onclick = handleDownloadAppClick;
}

window.onload = () => {
  const config = getConfig();
  const headerData = config.getStrict<IHeaderV1Schema>('headerData');
  const newHeaderEnabled = !!config.get<boolean>('newHeaderEnabled');
  const isAdaptive = config.get<boolean>('isAdaptive');
  const userIsAuthenticated = config.get<boolean>('userIsAuthenticated') as boolean;
  const linksBaseUrl = config.getStrict<string>('legacy.linksBaseUrl');
  const subdomain = config.getStrict<string>('subdomain');
  const isProfessionalSearchPromoEnabled = !!config.get<boolean>('isProfessionalSearchPromoEnabled');
  const favLink = `//${subdomain}.${linksBaseUrl}/rent/flat/favorites/`;

  setFingerprintCookie();
  removeRedwareCookies();
  initializeGeoSwitcher();

  initializeBottomMenu();

  //на всякий случай решил подстраховаться
  //непонятно зачем initializeDropdownMenus в setTimeout 1000
  let dropdownInitialized = false;
  if (window.__header_dropdown_menus_data__) {
    initializeDropdownMenus({
      newHeaderEnabled,
      headerData,
    });
    dropdownInitialized = true;
  }

  initializeNewTopMenu({
    newHeaderEnabled,
    headerData,
  });
  initializeCookieAgreement();
  initializeStuff();

  return setTimeout(() => {
    if (!dropdownInitialized) {
      initializeDropdownMenus({
        newHeaderEnabled,
        headerData,
      });
    }
    initializeNewTopMenu({
      newHeaderEnabled,
      headerData,
    });
    initializeSpecialPromoLink(newHeaderEnabled);
    initializeModerationCheckConstraint();
    initializeCheckAnounceRelevancePopup();
    initializeProlongationPopup();

    if (userIsAuthenticated) {
      initializeChatsNotificator();
    }

    if (newHeaderEnabled) {
      initializeNewChatsNotificator(headerData);
    }

    if (adaptiveMenu) {
      initializeNotificationCenter();
    }

    if (isAdaptive) {
      initializeChatsCounter();
    }

    initializeBackToAdPopup();
    initializeUserMenu(headerData, isProfessionalSearchPromoEnabled);
    initializeFavorites(favLink);
    initializeCookieAgreement();
  }, 1000);
};

const eventBus = getEventBusIfDefined();
if (eventBus) {
  eventBus.subscribe('header:category_changed', (event: CianEventBus.IEvent) => {
    const newHeaderEnabled = !!getConfig().get<boolean>('newHeaderEnabled');

    if (newHeaderEnabled) {
      setActiveNewBottomMenuItem(event.type);
    } else {
      setActiveBottomMenuItem(event.type);
    }
  });
}

window.reloadHeader = reloadHeader;
window.__reloadHeader__ = reloadHeader;
window.refreshAfterUserLoggedIn = reloadHeader;
window._headerTrackingEvent = submitGA;
window._realtorLinkTrackingEvent = trackRealtorMenuItemClick;
window._mortgageLinkTrackingEvent = trackMortgageMenuItemClick;
window._mortgageCalculatorTrackingEvent = trackMortgageCalculatorMenuItemClick;
window._mobileMenuTrackingEvent = submitMobileMenuGA;
window.waitForLoginPopup = waitForLoginPopup;
window.__header_updateFavorites__ = updateFavorites;
window._setNewbuildingConsultantPhone = setNewbuildingConsultantPhone;
